import { render, staticRenderFns } from "./refundedIndex.vue?vue&type=template&id=72b7f40f&scoped=true&"
import script from "./refundedIndex.vue?vue&type=script&lang=js&"
export * from "./refundedIndex.vue?vue&type=script&lang=js&"
import style0 from "./refundedIndex.vue?vue&type=style&index=0&id=72b7f40f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b7f40f",
  null
  
)

export default component.exports